import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BannerDto } from '../../../models/dtos/banner.dto';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getBannersRequest from './getBanners.repository';

type InitialState = {
  loading: boolean;
  data?: BannerDto[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getBanners = createAsyncThunk(
  'getBanners',
  async (teamId: number) => {
    return await getBannersRequest(teamId);
  }
);

const getBannersSlice = createSlice({
  name: 'getBanners',
  initialState,
  reducers: {
    getBannersReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBanners.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getBanners.fulfilled,
      (state, action: PayloadAction<BannerDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getBanners.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getBannersSlice.reducer;
export const { getBannersReset } = getBannersSlice.actions;
